import React from 'react';
import { Flex, IconButton, Box, Text } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useHistory, useLocation, Link } from 'react-router-dom';

export default function ContentHeader({ title, tabs = [] }) {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <Flex align="center" mt="0px" ml="40px">
      {/* 左側返回按鈕 */}
      <IconButton
        minW="30px"
        h="30px"
        borderRadius="30px"
        bgColor="#07B464"
        color="white"
        icon={<ArrowBackIcon />}
        aria-label="Back"
        onClick={() => history.goBack()}
        mr="20px"
      />

      {/* 如果有 tabs，顯示 tab 切換；否則顯示標題 */}
      {tabs.length > 0 ? (
        tabs.map((tab) => (
          <TabButton
            key={tab.path}
            to={tab.path}
            label={tab.label}
            isActive={tab.path === currentPath}
          />
        ))
      ) : (
        <Text
          bg="#1c734a"
          borderRadius="0px 0px 30px 30px"
          width="117px"
          height="50px"
          textAlign="center"
          color="#ffffff"
          fontSize="18px"
          fontWeight="bold"
          pt="10px"
        >
          {title}
        </Text>
      )}
    </Flex>
  );
}

function TabButton({ to, label, isActive }) {
  return (
    <Link to={to}>
      <Box
        textAlign="center"
        width="117px"
        height="50px"
        borderRadius="0px 0px 30px 30px"
        bg={isActive ? '#1c734a' : '#C1CCD1'}
        color={isActive ? '#ffffff' : '#F3F5F6'}
        fontSize="18px"
        fontWeight="bold"
        pt="10px"
        cursor="pointer"
        transition="all 0.2s ease"
        _hover={{
          opacity: 0.9,
        }}
      >
        {label}
      </Box>
    </Link>
  );
}
